import type { MetricCol } from "./types";

type MetricColumnDefinition = Pick<MetricCol, "key" | "type" | "num">;

export const METRIC_COLUMN_DEFS: MetricColumnDefinition[] = [
  { key: "impressions", type: "int" },
  { key: "clicks", type: "int" },
  { key: "registration", type: "int" },
  { key: "approved", type: "int" },
  { key: "funded", type: "int" },
  { key: "traded", type: "int" },
  {
    key: "cr_reg",
    type: "pct",
    num: "registration",
  },
  {
    key: "cr_app",
    type: "pct",
    num: "approved",
  },
  {
    key: "cr_funded",
    type: "pct",
    num: "funded",
  },
  {
    key: "cr_traded",
    type: "pct",
    num: "traded",
  },
  { key: "volume", type: "usd" },
  { key: "earnings", type: "usd" },
];
